<template>
  <div>
    <form
       class="search-box-form"
       @submit.prevent="handleSearchFormSubmit"
    >
      <textbox
          :placeholder="placeholder"
          class="search-box"
          v-model="localValue"
          id="searchBar"
      >
      </textbox>
      <button
          class="button is-primary search"
          @click.prevent="handleSearchFormSubmit"
      >
        <label>Submit</label>
        <i class="fa fa-search fa-2x" aria-hidden="true"></i>
      </button>
      <button
          v-if="localValue !== null && localValue !== ''"
          type="submit"
          class="button clear-button"
          @click.prevent="handleSearchFormClear"
      >
        CLEAR
        <i class="fas fa-times-circle"></i>
      </button>
      <slot name="address-candidates-slot" />
    </form>
  </div>
</template>

<script>

export default {
    name: 'SearchBox',
    props: {
        handleSearchFormSubmit: {
            type: Function,
            default() { console.log('handleFormX is running'); },
        },
        value: {
          type: [ String, Number ],
          default: '',
        },
        placeholder: {
          type: [ String, Number ],
          default: '',
        },
    },
    computed: {
      localValue: {
        get() {
          return this.value;
        },
        set(localValue) {
          this.$emit('input', localValue);
        },
      },
    },
    methods: {
      handleSearchFormClear(){
        return this.$emit('searchclear');
      }
    }
}
</script>
<style lang="scss">
button>label {
  visibility: hidden;
}


@media screen and (min-width: 768px){
  form.search-box-form {
    margin-right: -50px;
  }
}
@media screen and (max-width: 768px){
 div.search-bar>div>div>form.search-box-form {
      margin: 0 15px 0 15px;
  }
  div.input-wrap.search-box {
    width: calc(100% - 50px);
  }
  button.clear-button {
    display: none;
  }
  .clear-button {
    display: none;
  }
}

form.search-box-form {
  position: relative;
  // margin-right: -50px;
}
.input-wrap.search-box {
  padding-left: 0;
  width: calc(100% - 100px);
  display: inline-block;
  input {
    background-color: white;
  }
  .input::-webkit-input-placeholder, .textarea::-webkit-input-placeholder, .select select::-webkit-input-placeholder {
    color: unset;
  }
}
i.fa-search {
    margin-left: -8px;
}
button.button.clear-button {
  position: absolute;
  right: 120px;
  top: 25px;
  width: 70px;
  font-size: smaller;
  border: none;
  background: $ben-franklin-blue-light;
  color: $grey-dark;
  border-radius: 40px;
  // opacity: 0.8;
  height: 15px;
  i {
    margin-left: 5px;
  }
  &:focus {
    box-shadow: none !important;
  }
}
button.is-primary.search {
  display: inline-block;
  margin: 8px 0 8px -8px;
  width: 50px;
  height: 3.5rem;
  margin-right: 1.5px;
  background-color: $ben-franklin-blue-dark;
  &:focus {
    box-shadow: none !important;
  }
  i {
    left: 20%;
    top: 20%;
    margin: auto;
    position: absolute;
  }

}
</style>